import AppState from '@webapp/store/state';
import { TracInviteTypes } from '@services/invites/types/invite-types';

export const currentInviteList = (state: AppState, type: TracInviteTypes) => {
  return Object.values(state.invites.current[type])
    .sort((a, b) => Number(b.created_at) - Number(a.created_at))
}

export const newInviteList = (state: AppState, type: TracInviteTypes, filterEmpty?: boolean) => {
  return Object
    .values(state.invites.new[type])
    .filter((i) => filterEmpty ? !!i.email_or_phone : true);
}